// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const UndoIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="UndoIcon" ref={forwardedRef} {...props}>
      <path d="M2 8.243 6.243 4l1.06 1.06L4.87 7.496H16a1 1 0 0 1 1 1v4.5a1 1 0 0 1-1 1h-4v-1.5h3.5v-3.5H4.873l2.43 2.43-1.06 1.06z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const UndoIcon = /* @__PURE__ */ Object.assign(UndoIconComponent, {
  displayName: 'UndoIcon',
});
